import ReactHtmlParser from 'react-html-parser';
import Banner from '../../components/Banner';
import useAnimations from '../../helpers/animations';

function AboutBanner({ data }) {;
    useAnimations({
        usedFor: 'entry-banner',
        sections: [],
    });

    const [title_part1, title_part2] =
        data?.about_header?.title ? data.about_header.title.split('-') : [];

    return (
        <Banner
            banner="about-page-banner"
            backgroundBanner={data?.about_header.img_url}
            activeTab="about-haydon"
        >
            <div className="container">
                <div className="text-content d-flex">
                    <h1 className="font-light">
                        {title_part1} <span>{title_part2}</span>
                    </h1>
                    <div className="text">
                        {ReactHtmlParser(data?.about_header.description)}
                    </div>
                </div>
            </div>
        </Banner>
    );
};

export default AboutBanner;
